export const BigMeshIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="60"
      height="34"
      viewBox="0 0 60 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.63717 0.90918L0.499999 10.3686L5.85177 15.7929L9.63717 11.9562L9.63717 33.091L18.7091 33.091L29.38 17.8435L29.38 33.091L38.5824 33.091L49.2533 17.8435L49.2533 33.091L59.5 33.091L59.5 0.909185L50.6239 0.909184L39.6267 16.752L39.6267 0.909183L30.7179 0.909182L19.8186 16.752L19.8186 0.909181L9.63717 0.90918Z"
        fill="white"
      />
    </svg>
  )
}
